import * as RxSelect from '@radix-ui/react-select';

import Text from '../base/Text';
import ChevronDropdownIcon from '../icons/ChevronDropdownIcon';
import { input } from './Input';

export type SelectItem = {
  value: string | number;
  label: string;
  description?: string;
};

export default function Select({
  inModal = false,
  items,
  value,
  onValueChange,
  className,
  placeholder,
}: {
  inModal?: boolean;
  items: Array<SelectItem>;
  value?: string | number;
  onValueChange?: (value: string) => void;
  className?: string;
  placeholder?: string;
}) {
  return (
    <RxSelect.Root value={value?.toString()} onValueChange={onValueChange}>
      <RxSelect.Trigger
        className={input({
          className: `flex w-full items-center justify-between ${className}`,
        })}
        aria-label="Food"
      >
        <RxSelect.Value
          placeholder={
            <Text variant="studio/body/medium/sm" className="text-gray-45">
              {placeholder}
            </Text>
          }
        />
        <RxSelect.Icon className="text-gray-45 dark:text-gray-60 relative left-1">
          <ChevronDropdownIcon />
        </RxSelect.Icon>
      </RxSelect.Trigger>
      <RxSelect.Portal>
        <RxSelect.Content
          className={`shadow-menu dark:bg-gray-75 relative ${
            inModal ? 'z-[70]' : 'z-10'
          } overflow-hidden rounded-2xl bg-white`}
        >
          <RxSelect.Viewport className="p-2">
            <RxSelect.Group>
              {items.map((item) => (
                <RxSelect.Item
                  key={item.value}
                  className="hover:bg-blue outline-hidden group flex min-h-10 cursor-pointer flex-col items-start justify-center gap-0.5 rounded-lg px-4 py-2 hover:text-white"
                  value={item.value.toString()}
                >
                  <div className="flex w-full flex-1 items-center justify-between gap-2">
                    <RxSelect.ItemText>
                      <Text variant="studio/body/medium/sm">{item.label}</Text>
                    </RxSelect.ItemText>
                    <RxSelect.ItemIndicator className="SelectItemIndicator">
                      <Dot />
                    </RxSelect.ItemIndicator>
                  </div>
                  {item.description && (
                    <Text
                      variant="studio/body/sm"
                      className="text-gray-60 group-hover:text-white"
                    >
                      {item.description}
                    </Text>
                  )}
                </RxSelect.Item>
              ))}
            </RxSelect.Group>
          </RxSelect.Viewport>
        </RxSelect.Content>
      </RxSelect.Portal>
    </RxSelect.Root>
  );
}

const Dot = () => {
  return (
    <svg
      width="6"
      height="6"
      viewBox="0 0 6 6"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="3" cy="3" r="3" />
    </svg>
  );
};
